import styled from 'styled-components';

import { FieldMappingTextEditor } from '@components/text-editors';
import {
  BaseFieldMappingFieldProps,
  ExtendedFieldMappingEditorValue,
  FieldMappingData,
  transformSimpleValueOutput,
} from '@components/text-editors/addons/field-mapping';
import { pxToRem } from '@utils/converters';

import { transformTextToEmailNode, Email, transformInput, tag } from './extensions';

export type EmailListFieldProps = Omit<
  BaseFieldMappingFieldProps<ExtendedFieldMappingEditorValue[]>,
  keyof FieldMappingData
> & {
  single?: boolean;
  hasResetError?: boolean;
} & FieldMappingData;

export const EmailListField = ({
  defaultValue,
  onChange,
  single = false,
  extensions,
  ...rest
}: EmailListFieldProps) => {
  return (
    <NodeStyledFieldMappingTextEditor
      extensions={extensions ?? [Email.configure({ single })]}
      plaintext
      singleLine
      onChange={(value) => onChange?.(transformSimpleValueOutput(value, tag))}
      onEditorBlur={transformTextToEmailNode}
      defaultValue={defaultValue ? transformInput(defaultValue) : undefined}
      fieldType="email"
      {...rest}
    />
  );
};

const NodeStyledFieldMappingTextEditor = styled(FieldMappingTextEditor)({
  '.node-wrapper': {
    marginRight: pxToRem(8),
  },
});
